export const REPORT_GROUPS_SET_DATA_LOADING_STATE = 'REPORT_GROUPS_SET_DATA_LOADING_STATE';
export const REPORT_GROUPS_SET_REQUEST_LOADING_STATE = 'REPORT_GROUPS_SET_REQUEST_LOADING_STATE';
export const REPORT_GROUPS_SET_ERROR = 'REPORT_GROUPS_SET_ERROR';
export const REPORT_GROUPS_RESET_ERROR = 'REPORT_GROUPS_RESET_ERROR';
export const REPORT_GROUPS_SET_GROUPS = 'REPORT_GROUPS_SET_GROUPS';
export const REPORT_GROUPS_SET_MARKETS = 'REPORT_GROUPS_SET_MARKETS';
export const REPORT_GROUPS_SET_FILTER_STRING = 'REPORT_GROUPS_SET_FILTER_STRING';
export const REPORT_GROUPS_SET_REMOVE_ITEM_FROM_STATE = 'REPORT_GROUPS_SET_REMOVE_ITEM_FROM_STATE';
